import Typewriter from "./type-writer";
import Text from "./text";
import Image from "./../image";

interface ChatTextProps {
  fromChatBot: boolean;
  text: string;
  className?: string;
  useTypeWriter: boolean;
}

const ChatText: React.FC<ChatTextProps> = ({
  fromChatBot = true,
  text,
  className,
  useTypeWriter = false,
}) => {
  return (
    <div className={`flex ${fromChatBot ? "justify-start" : "justify-end"}`}>
      <div
        className={`flex items-start chat-text text-white text-lg ${className} ${
          fromChatBot ? "chat-text--bot" : "chat-text--user"
        }`}
      >
        {fromChatBot && (
          <Image
            className="mr-[8px]"
            aria-hidden
            src="/assets/icon_ai_agent.png"
            alt="next icon"
            width={24}
            height={24}
          />
        )}
        {!useTypeWriter ? <div className="whitespace-pre-line">{text}</div> : <Typewriter text={text} />}
      </div>
    </div>
  );
};

export default ChatText;
